import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { cloneDeep } from 'lodash';
let Threshold = class Threshold extends VuexModule {
    thresholdValue = {
        value: 10,
        minor: '',
        critical: '',
        major: '',
        minorTime: '',
        criticalTime: '',
        majorTime: '',
        enabledAlarmLevels: [],
        enabledTimeAlarmLevels: [],
    };
    updataThreshold(value) {
        if (value && this.thresholdValue) {
            this.thresholdValue = cloneDeep(value);
        }
    }
};
__decorate([
    Mutation
], Threshold.prototype, "updataThreshold", null);
Threshold = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/Threshold' })
], Threshold);
export const ThresholdModule = getModule(Threshold);
